import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result, ValueObject } from '@digibricks/core';
export var BanReasonCode = /*#__PURE__*/function (_ValueObject) {
  _inherits(BanReasonCode, _ValueObject);

  var _super = _createSuper(BanReasonCode);

  function BanReasonCode() {
    _classCallCheck(this, BanReasonCode);

    return _super.apply(this, arguments);
  }

  _createClass(BanReasonCode, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "create",
    value: function create(value) {
      if (!this.resources.includes(value)) {
        return new BadInputError('Unknown ban reason code');
      }

      return Result.ok(new BanReasonCode(value));
    }
  }]);

  return BanReasonCode;
}(ValueObject);

_defineProperty(BanReasonCode, "resources", ['SECURITY_VIOLATION_LIMIT', 'MANUAL']);

_defineProperty(BanReasonCode, "securityViolationLimit", BanReasonCode.create(BanReasonCode.resources[0]).getValue());

_defineProperty(BanReasonCode, "manual", BanReasonCode.create(BanReasonCode.resources[1]).getValue());